// ** MUI Imports
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import MuiListSubheader from '@mui/material/ListSubheader'
import Divider from '@mui/material/Divider'
import { Box, ListItem } from '@mui/material'
import { useTheme } from '@mui/material/styles'

// ** Icon Imports
import Icon from '../../../../components/icon'

// ** Custom Components Imports
// import Translations from 'src/layouts/components/Translations'
import CanViewNavSectionTitle from '../../../../components/layouts/components/acl/CanViewNavSectionTitle'

// ** Styled Components
const ListSubheader = styled(props => <MuiListSubheader component='li' {...props} />)(({ theme }) => ({
  lineHeight: 1,
  display: 'flex',
  position: 'static',
  marginTop: theme.spacing(1),
  paddingTop: theme.spacing(1),
  backgroundColor: 'transparent',
  paddingBottom: theme.spacing(1),
  transition: 'padding-left .25s ease-in-out'
}))

const VerticalNavSectionTitle = props => {
  // ** Props
  const { item, navHover, settings, collapsedNavWidth, navigationBorderWidth } = props
  
  // ** Vars
  const { navCollapsed } = settings

  const theme = useTheme();

  return (
    // <CanViewNavSectionTitle navTitle={item}>
    // <ListSubheader>
      // <Divider
      //   sx={{
      //     color: "text.disabled",
      //     "& .MuiDivider-wrapper": { px: 6 },
      //     fontSize: theme.typography.body2.fontSize,
      //     my: (theme) => `${theme.spacing(3)} !important`,
      //   }}
      // />
    // </ListSubheader>
      <ListSubheader
        className='nav-section-title'
        sx={{
          ...(navCollapsed && !navHover
            ? { py: 0.5, px: (collapsedNavWidth - navigationBorderWidth - 22) / 8 }
            : { px: 7.5 }),
        }}
      >
        <Divider
          sx={{
            color: "text.disabled",
            fontSize: theme.typography.body2.fontSize,
            width: '100%',
            height: '1px',
            // marginY: theme.spacing(1.5),
          }}
        />
        {/* <Divider
          variant="middle"
          sx={{
            backgroundColor: theme.palette.text.disabled,
            my: theme.spacing(2),
            mx: navCollapsed && !navHover ? 0 : theme.spacing(1),
          }}
        /> */}
        {/* <Icon icon='tabler:separator' sx={{ width: 'fit-content !important' }} /> */}
        {/* {navCollapsed && !navHover ? (
        <Icon icon='tabler:separator' />
        ) : (
          <Typography noWrap variant='caption' sx={{ textTransform: 'uppercase' }}>
            {item.sectionTitle}
          </Typography>
        )} */}
      </ListSubheader>
    // </CanViewNavSectionTitle>
  )
}

export default VerticalNavSectionTitle
